import { Link, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import config from "../../config/config";
import { checkUserPermission } from "../../common/UserPermission";
import { Noimage } from "../../common/imagePath";
import moment from "moment";
import Select from "react-select";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../common/Constant";
import Loader from "../Loader/Loader";
import CommonDatePicker from "../DatePicker/CommonDatePicker";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { AppContext } from "../../context/AppContext";
import CurrencySymbols from "../../common/CurrencySymbol";

const ItemsDetailsModal = ({ id, setItemsId, saleCustomerId, receivingSupplierId }) => {

  console.log(saleCustomerId,"saleCustomerId");
  console.log(receivingSupplierId,"receivingSupplierId");
  

// Set last 7 days
const startLast7Days = moment().subtract(7, 'days').format('YYYY-MM-DD');
const endLast7Days = moment().format('YYYY-MM-DD');

// Set current week start and end
const startCurrentWeek = moment().startOf('week').format('YYYY-MM-DD');
const endCurrentWeek = moment().endOf('week').format('YYYY-MM-DD');

// Set last week start and end
const startLastWeek = moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD');
const endLastWeek = moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD');

// Set current month start and end
const startCurrentMonth = moment().startOf('month').format('YYYY-MM-DD');
const endCurrentMonth = moment().endOf('month').format('YYYY-MM-DD');

// Set last month start and end
const startLastMonth = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
const endLastMonth = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');

// Set last 365 days
const startLast365Days = moment().subtract(365, 'days').format('YYYY-MM-DD');
const endLast365Days = moment().format('YYYY-MM-DD');


  const { dateFormate, CurrencySymbol, FractionDigits } = useContext(AppContext);
  const [toggleItemsPrice, setToggleItemsPrice] = useState(false);
  const [toggleItemVariationPrice, setToggleItemVariationPrice] =
    useState(false);
  const [itemsDetailsData, setItemsDetailsData] = useState();
  const [itemsInventoryData, setItemsInventoryData] = useState([]);
  const [variationDropdown, setVariationDropdown] = useState([]);
  const [itemsVelocityData, setItemsVelocitydata] = useState([]);
  const [variationId, setVariationId] = useState(0);
  const [customerId, setCustomerId] = useState(0);
  const [supplierId, setSupplierId] = useState(0);
  const [transitionId, setTransitionId] = useState(0);
  // const [isVariableSet, setIsVariableSet] = useState(true);
  const [loading, setLoading] = useState(false);
  const [startingDate, setStartingDate] = useState(startLast7Days);
  const [endingDate, setEndingDate] = useState(endLast7Days);
  const [selectDateChangeId, setSelectDateChangeId] = useState(7);

  const [custoptions, setCustOptions] = useState([]);
  const [recoptions, setRecOptions] = useState([]);
  const [transactiondropdown, setTransactionDropdown] = useState([]);

  const [selectedOption, setSelectedOption] = useState("");
  const navigate = useNavigate();
  console.log(custoptions, recoptions, transactiondropdown, "dropdownlistdata");
  console.log(toggleItemsPrice,toggleItemVariationPrice, "toggleItemsPrice");
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");

  console.log(id, "id of the item which i am checking");

  const options = [
    { label: "All", value: 1 },
    { label: "Last 7 Day", value: 7 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const exportOptions = [
    { label: "Excel Full list", value: "excel_full_list" },
    { label: "Excel Instock with qty", value: "excel_instock_qty" },
    { label: "Excel Instock without qty", value: "excel_instock_no_qty" },
    { label: "PDF Full list", value: "pdf_full_list" },
    { label: "PDF Instock with qty", value: "pdf_instock_qty" },
    { label: "PDF Instock without qty", value: "pdf_instock_no_qty" },
  ];

  const handleExport = () => {
    switch (selectedOption) {
      case "excel_full_list":
        handleExcelExport(true, false);
        break;
      case "excel_instock_qty":
        handleExcelExport(true, true);
        break;
      case "excel_instock_no_qty":
        handleExcelExport(false, true);
        break;
      case "pdf_full_list":
        handlePdfExport(true, false);
        break;
      case "pdf_instock_qty":
        handlePdfExport(true, true);
        break;
      case "pdf_instock_no_qty":
        handlePdfExport(false, true);
        break;
      default:
        alert("Please select a valid option");
    }
  };

  const handleExcelExport = (showQuantity, inStock) => {
    const data = itemsDetailsData?.Inventory.length > 0 ? itemsDetailsData?.Inventory : [];

    // Filter based on inStock condition
    const filteredData = inStock
      ? data.filter(item => item.Quantity > 0)
      : data;

    const processedData = filteredData.map(item => {
      let row = {
        ItemName: item.Variation,
        // ReplenishLevel: Number(item.ReplenishLevel).toFixed(2),
        // ReorderLevel: Number(item.ReorderLevel).toFixed(2),
      };

      if (showQuantity) {
        row.Quantity = item.Quantity;
      }

      return row;
    });

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(processedData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const fileName = showQuantity ? 'items_inventory_with_qty.xlsx' : 'items_inventory_no_qty.xlsx';
    XLSX.writeFile(workbook, fileName);
  };

  const handlePdfExport = (showQuantity, inStock) => {
    const data = itemsDetailsData?.Inventory.filter(item => inStock ? item.Quantity > 0 : true) || [];

    const filteredData = data.map(item => ({
      ItemName: item.Variation,
      Quantity: showQuantity ? item.Quantity : undefined,
      // ReplenishLevel: Number(item.ReplenishLevel).toFixed(2),
      // ReorderLevel: Number(item.ReorderLevel).toFixed(2)
    }));

    const columns = ["Item Name", ...(showQuantity ? ["Quantity"] : [])];
    const rows = filteredData.map(item => [
      item.ItemName,
      ...(showQuantity ? [item.Quantity] : []),
      // item.ReplenishLevel,
      // item.ReorderLevel,
    ]);

    const doc = new jsPDF();
    doc.autoTable({
      head: [columns],
      body: rows,
    });

    const fileName = showQuantity ? 'items_inventory_with_qty.pdf' : 'items_inventory_no_qty.pdf';
    doc.save(fileName);
  };


  const edithandel = (e) => {
    navigate(`/manage-Items/${itemsDetailsData?.ItemInfo[0]?.ID}`);
  };
  const generateBarcode = (e) => {
    const ItemID = itemsDetailsData?.ItemInfo[0]?.ID;
    const variationsData = itemsDetailsData?.ItemVariations;
    console.log(variationsData, "variationsData 052024");

    const newArray = variationsData?.map((item) => ({
      variationId: item.ID,
      itemId: ItemID,
    }));

    const barcodeRequestParam = {
      id: newArray,
    };

    console.log(newArray, "newArray 052024");
    console.log(barcodeRequestParam, "newArray 052024");

    localStorage.setItem(
      "BarcodeItemRequestParam",
      JSON.stringify(barcodeRequestParam)
    );

    // return
    navigate(`/item-barcode-label`);
  };

  useEffect(() => {
    if (id > 0) {
      setLoading(true);
      let salesCustomerId = saleCustomerId ? saleCustomerId : 0;
      let receivingsSupplierId = receivingSupplierId ? receivingSupplierId : 0;
      axios
        .get(
          `${config.itemsBaseUrl}/items/detailsbinding?itemid=${id}&LocationID=${location}&customerId=${salesCustomerId}&supplierId=${receivingsSupplierId}&variationId=${variationId}&transitionId=${transitionId}&startingDate=${startingDate}&endingDate=${endingDate}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          // this.setState({ data: res.data.ResponseData });
          if (res.data?.ResponseData != undefined) {
            if (id > 0) {
              setItemsDetailsData(res.data.ResponseData);
            }
            // setLoading(false);
          }
          console.log("Show POPUP data =>", res.data.ResponseData);
        }).catch((err) => {
          console.log("err: ", err);
          // setLoading(false);
        });

      // Get the current date
      const endDate = moment().format("YYYY-MM-DD");
      // Get the date 30 days ago
      const startDate = moment().subtract(30, "days").format("YYYY-MM-DD");
      setLoading(true);
      axios
        .get(
          `${config.itemsBaseUrl}/items/inventoryquantitylisting?ItemID=${id}&Locationid=${location}&SupplierId=${supplierId}&CustomerId=${customerId}&TransactionType=${transitionId}&startDate=${startingDate}&endDate=${endingDate}&variation=${variationId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setItemsInventoryData(res.data.ResponseData?.inventoryData);

          const FilterVariationList = res.data.ResponseData?.variationList?.map(
            (el) => {
              return { label: el.Name, value: el.ID, ItemId: el.ItemId };
            }
          );
          setVariationDropdown(FilterVariationList);
          setLoading(false);
        })
        .catch((err) => {
          console.log("err: ", err);
          setLoading(false);
        });
        axios
        .get(
        `${
          config.reportsBaseUrl
        }/reports/salesvelocityreport?&brandid=&categoryid=&locationid=${location}&selectedItems=${encodeURIComponent(
          JSON.stringify([])
        )}&itemid=${id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
        .then((res) => {
          setItemsVelocitydata(res.data.ResponseData);
          setLoading(false);
        })
        .catch((err) => {
          console.log("err: ", err);
          setLoading(false);
        });
    }
  }, [id, variationId, transitionId, supplierId, customerId, startingDate,endingDate]);

  useEffect(() => {
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log(response.data.ResponseData, "===> setCustOptions");
        const customerListData = response.data.ResponseData;
        const customerDropDown = customerListData.map((option) => ({
          value: option.Id,
          label:
            option.CompanyName
            //  +
            // "(" +
            // option.FirstName +
            // " " +
            // option.LastName +
            // ")"
            ,
          address: option.Address1,
          email: option.Email,
        }));
        setCustOptions(customerDropDown);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("supplyer list", response.data.ResponseData);
        const supplierListData = response.data.ResponseData;
        const supplierDropDown = supplierListData.map((option) => ({
          value: option.ID,
          label:
            option.CompanyName 
            // +
            // "(" +
            // option.FirstName +
            // " " +
            // option.LastName +
            // ")"
            , // option.FirstName + " " + option.LastName,
          address: option.Address,
        }));
        setRecOptions(supplierDropDown);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.itemsBaseUrl}/items/inventorytransaction`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("supplyer list", response.data.ResponseData);
        const transactionListData = response.data.ResponseData;

        const inventorydropdown = transactionListData.map((option) => ({
          value: option.ID,
          label: option.Type,
        }));

        setTransactionDropdown(inventorydropdown);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const getListByInventoryID = itemsDetailsData?.Inventory.filter(
    (item) => item.LocationId === 45
  );
  console.log(itemsDetailsData, "itemsDetailsData");

  
  const handleStartDateChange = (newDate) => {
    setStartingDate(newDate);
  }
  const handleEndDateChange = (newDate) => {
    setEndingDate(newDate);
  }

  const handleDateSelectChange = (event) => {
    setSelectDateChangeId(event.value)
    if(event?.value == 2){
      return;
    }
    // All Condition
    if (event?.value == 1) {
      setStartingDate(startLast365Days);
      setEndingDate(endLast365Days);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      setStartingDate(startLastWeek);
      setEndingDate(endLastWeek);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      setStartingDate(startCurrentWeek);
      setEndingDate(endCurrentWeek);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      setStartingDate(startLastMonth);
      setEndingDate(endLastMonth);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      setStartingDate(startCurrentMonth);
      setEndingDate(endCurrentMonth);
    }
    // Last 7 day Condition
    else if (event?.value == 7) {
      setStartingDate(startLast7Days);
      setEndingDate(endLast7Days);
    }
  };

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return '';
    return sortConfig.direction === 'asc' ? ' ▲' : ' ▼';
  };

  const sortedInventory = useMemo(() => {
    if (!itemsVelocityData) return [];

    const sorted = [...itemsVelocityData];

    if (sortConfig.key !== null) {
      sorted.sort((a, b) => {
        const valA = a[sortConfig.key];
        const valB = b[sortConfig.key];

        if (valA === null || valA === undefined) return 1;
        if (valB === null || valB === undefined) return -1;

        if (!isNaN(valA) && !isNaN(valB)) {
          return sortConfig.direction === 'asc' ? valA - valB : valB - valA;
        }

        return sortConfig.direction === 'asc'
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      });
    }

    return sorted;
  }, [itemsVelocityData, sortConfig]);

  return (
    <>
      <Loader loading={loading} />
      <div
        className="modal fade"
        id="ItemsDetailsModal"
        tabIndex={-1}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-fullscreen modal-dialog-centered"
          role="document"
        >
          <div className="modal-content" style={{ minHeight: "500px" }}>
            <div className="modal-header">
              <p className="modal-title p-lg">
                {itemsDetailsData?.ItemInfo[0].Name} [ID:{" "}
                {itemsDetailsData?.ItemInfo[0].ID}]{" "}
              </p>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setItemsId(0);
                  setVariationId(0);
                  setTransitionId(0);
                  setSupplierId(0);
                  setCustomerId(0);
                  setSelectedOption("");
                  // setIsVariableSet(true);
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div>
                    <ul className="nav nav-tabs d-flex justify-content-between">
                      <div className="d-flex">
                        <li className="nav-item fs-5">
                          <a
                            className="nav-link active"
                            href="#ItemsDetailsTabOpen1"
                            data-bs-toggle="tab"
                          >
                            Item Info
                          </a>
                        </li>
                        <li className="nav-item fs-5">
                          <a
                            className="nav-link"
                            href="#ItemsDetailsTabOpen2"
                            data-bs-toggle="tab"
                          >
                            Pricing
                          </a>
                        </li>
                        <li className="nav-item fs-5">
                          <a
                            className="nav-link"
                            href="#ItemsDetailsTabOpen3"
                            data-bs-toggle="tab"
                          >
                            Inventory
                          </a>
                        </li>
                        <li className="nav-item fs-5">
                          <a
                            className="nav-link"
                            href="#ItemsDetailsTabOpen4"
                            data-bs-toggle="tab"
                          >
                            Images
                          </a>
                        </li>
                        <li className="nav-item fs-5">
                          <a
                            className="nav-link"
                            href="#ItemsDetailsTabOpen5"
                            data-bs-toggle="tab"
                          >
                            Item Inventory Log
                          </a>
                        </li>
                        <li className="nav-item fs-5">
                          <a
                            className="nav-link"
                            href="#ItemsDetailsTabOpen6"
                            data-bs-toggle="tab"
                          >
                            Sales Velocity Report
                          </a>
                        </li>
                      </div>

                    <div className="d-flex">
                    {/* <button
                      className="btn btn-sm btn-outline-dark btn-sm mr-3 mb-3"
                      onClick={() => handleExcelExport(true)} // Pass true to show quantity
                      title="Export to excel"
                    >
                      Export Excel (Qty)
                    </button>
                    <button
                      className="btn btn-sm btn-outline-dark btn-sm mr-3 mb-3"
                      onClick={() => handleExcelExport(false)} // Pass false to hide quantity
                      title="Export to excel"
                    >
                      Export Excel (No Qty)
                    </button>
                 
                    <button
                      className="btn btn-sm btn-outline-dark btn-sm mr-3 mb-3"
                      onClick={() => handlePdfExport(true)} // Pass true for showing Quantity
                      title="Download PDF"
                    >
                      Download PDF (Qty)
                    </button>
                    <button
                      className="btn btn-sm btn-outline-dark btn-sm mr-3 mb-3"
                      onClick={() => handlePdfExport(false)} // Pass false for hiding Quantity
                      title="Download PDF"
                    >
                      Download PDF (No Qty)
                    </button> */}

                        {/* <div> */}
                          {/* <select
                            className="form-select mb-3"
                            value={selectedOption}
                            onChange={e => setSelectedOption(e.target.value)}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          >
                            <option value="">Select Export Option</option>
                            {exportOptions.map(option => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select> */}
                          <Select
                            onChange={(event) => setSelectedOption(event ? event.value : "")}
                            options={exportOptions}
                            // value={exportOptions.find((option) => option?.value === selectedOption)}
                            value={selectedOption === "" ? null : exportOptions.find((option) => option?.value === selectedOption)}
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            isClearable={true}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            placeholder={"Select Download Option"}
                            className="custom-search-select"
                          />

                          {selectedOption && (
                            <button
                              className="btn btn-sm btn-outline-dark btn-sm mb-3 ml-2"
                              onClick={handleExport}
                              title="Download"
                            >
                             Download 
                           </button>
                           )}
                        {/* </div> */}

                      <button
                        className="btn btn-sm btn-outline-dark btn-sm mb-3 ml-2"
                        // style={{ marginBottom: "10px" }}
                        type="button"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={(e) => edithandel(e)}
                      >
                        Edit
                      </button>
                      </div>
                    </ul>
                  </div>
                  <div className="tab-content">
                    <div className="tab-pane active show" id="ItemsDetailsTabOpen1">
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  <th colSpan={2}>
                                    <p
                                      className="p-medium"
                                      style={{
                                        color: "var(--primary-main-color)",
                                      }}
                                    >
                                      <i
                                        class="fa fa-info-circle  fa-lg mr-3"
                                        aria-hidden="true"
                                      ></i>
                                      Item Information
                                    </p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="col-md-3">Category</td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0].Category}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">Brand</td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0].BrandName}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">Description</td>
                                  <td
                                    style={{
                                      wordWrap: "break-word",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {itemsDetailsData?.ItemInfo[0].Description}
                                  </td>
                                </tr>

                                <tr>
                                  <td className="col-md-5">Item Id</td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0].ID}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">Product ID</td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0].ProductID}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">UPC/EAN/ISBN</td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0].Itemnumber}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">
                                    Allow Alt Description
                                  </td>

                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0]
                                      .Allowaltdescription == 1
                                      ? "Yes"
                                      : "No"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">
                                    Item has Serial Number
                                  </td>
                                  <td className="col-md-9">
                                    {itemsDetailsData?.ItemInfo[0]
                                      .IsItemserialnumber == 1
                                      ? "Yes"
                                      : "No"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="col-md-3">
                                    Generate Barcodes
                                  </td>
                                  <td className="col-md-9">
                                    {" "}
                                    <p
                                      onClick={() => generateBarcode()}
                                      className="cursor-pointer"
                                    >
                                      Print
                                    </p>{" "}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            {itemsDetailsData?.ItemVariations.length > 0 ? (
                              <table className="table mb-0 table-border">
                                <thead>
                                  <tr>
                                    <th colSpan={2}>
                                      <p
                                        className="p-medium ml-2"
                                        style={{
                                          color: "var(--primary-main-color)",
                                        }}
                                      >
                                        <i
                                          className="fa fa-th-list fa-lg mr-3"
                                          aria-hidden="true"
                                        ></i>
                                        Item Variations
                                      </p>
                                    </th>
                                    <th></th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td className="col-md-1"></td>
                                    <td className="col-md-3">Name</td>
                                    <td className="col-md-3">Attributes</td>
                                    {/* {checkUserPermission("suppliers") && (
                                    )} */}
                                    <td className="col-md-5">Supplier</td>
                                  </tr>
                                  {itemsDetailsData.ItemVariations.map(
                                    (items, index) => (
                                      <tr key={index}>
                                        <td>
                                          <img
                                            src={items.ImageName}
                                            onError={(e) => {
                                              e.currentTarget.src =
                                                Noimage ||
                                                "path/to/fallback/image.jpg";
                                            }}
                                            // alt={props.Name}
                                            className="img-thumbnail mr-5"
                                            width="45"
                                            height="45"
                                          />
                                        </td>
                                        <td className="col-md-3">
                                          {items.Name}
                                        </td>
                                        <td className="col-md-3">
                                          {items.Attribute}
                                        </td>
                                        {/* {checkUserPermission("suppliers") && (
                                         
                                        )} */}
                                        <td className="col-md-3">
                                          {items.Supplier}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            ) : (
                              <div></div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="ItemsDetailsTabOpen2">
                      {/* <div className="row"> */}
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  <th colSpan={12}>
                                    <p
                                      className="p-medium"
                                      style={{
                                        color: "var(--primary-main-color)",
                                      }}
                                    >
                                      <i
                                        class="fa fa-money mr-3"
                                        aria-hidden="true"
                                      ></i>
                                      Pricing
                                    </p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="col-1">Selling Price</td>
                                  <td className="col-1">
                                  {CurrencySymbols(
                                            Number(itemsDetailsData?.ItemInfo[0].Unitprice),
                                            { CurrencySymbol },
                                            FractionDigits
                                    )}
                                  </td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                </tr>
                                {itemsDetailsData?.ItemInfo[0].HasVariations == 0 && saleCustomerId &&(
                                  <>
                                <tr>
                                  <td className="col-1">Last Selling Price</td>
                                  <td className="col-1">
                                  {CurrencySymbols(
                                            Number(itemsDetailsData?.ItemInfo[0].ItemSaleTotal),
                                            { CurrencySymbol },
                                            FractionDigits
                                    )}
                                  </td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                </tr>
                                <tr>
                                  <td className="col-1">Last Selling Date</td>
                                  <td className="col-1">
                                  {itemsDetailsData?.ItemInfo[0]?.ItemInvoiceDate 
                                    ? moment(itemsDetailsData.ItemInfo[0].ItemInvoiceDate).format(dateFormate.toUpperCase()) 
                                    : ""}
                                  </td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                </tr>
                                </>
                                )}
                                {checkUserPermission("show-cost-price") && (
                                  
                                  <><tr>
                                    <td className="col-md-1">Cost Price</td>
                                    <td className="col-md-1">
                                      {toggleItemsPrice &&
                                        CurrencySymbols(Number(
                                          itemsDetailsData?.ItemInfo[0]
                                            .Costprice
                                        ),{ CurrencySymbol },
                                        FractionDigits)}
                                      <Link
                                        type="button"
                                        className="btn btn-sm btn-outline-dark"
                                        style={{
                                          height: "28px",
                                          width: "25px",
                                        }}
                                        onClick={() =>
                                          setToggleItemsPrice(!toggleItemsPrice)
                                        }
                                      >
                                        {!toggleItemsPrice ? (
                                          <>
                                            <i className="fa fa-plus"></i>{" "}
                                          </>
                                        ) : (
                                          <>
                                            <i className="fa fa-minus"></i>{" "}
                                          </>
                                        )}
                                      </Link>
                                    </td>
                                    <td className="col-1"></td>
                                    <td className="col-1"></td>
                                    <td className="col-1"></td>
                                    <td className="col-1"></td>
                                    <td className="col-1"></td>
                                    <td className="col-1"></td>
                                  </tr>
                                  {itemsDetailsData?.ItemInfo[0].HasVariations == 0 && (saleCustomerId || receivingSupplierId) && (
                                  <>
                                <tr>
                                  <td className="col-md-1">Last Receiving Price</td>
                                  {toggleItemsPrice && (
                                    <td className="col-md-1">
                                    {CurrencySymbols(
                                              Number(itemsDetailsData?.ItemInfo[0].ItemBillTotal),
                                              { CurrencySymbol },
                                              FractionDigits
                                      )}
                                    </td>
                                  )}
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                </tr>
                                <tr>
                                  <td className="col-md-1">Last Receiving Date</td>
                                  {toggleItemsPrice && (
                                    <td className="col-md-1">
                                    {itemsDetailsData?.ItemInfo[0]?.ItemBillDate 
                                      ? moment(itemsDetailsData.ItemInfo[0].ItemBillDate).format(dateFormate.toUpperCase()) 
                                      : ""}
                                    </td>
                                  )}
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                </tr>
                                <tr>
                                  <td className="col-md-1">Supplier Name</td>
                                  {toggleItemsPrice && (
                                    <td className="col-md-1">
                                    {itemsDetailsData?.ItemInfo[0]?.ItemSupplierName}
                                    </td>
                                  )}
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                  <td className="col-1"></td>
                                </tr>
                                </>
                                )}
                                  </>
                                )}
                                {itemsDetailsData?.Pricing.length > 0 && (
                                  <>
                                <tr>
                                  <th className="col-1">Variation</th>
                                  <th className="col-1">Selling Price</th>
                                  {saleCustomerId &&( 
                                    <>
                                      <th className="col-1">Last Selling Price</th>
                                      <th className="col-1">Last Selling Date</th>
                                    </>
                                  )}
                                  {checkUserPermission("show-cost-price") && (
                                    <>
                                    <th className="col-1">
                                      Cost Price
                                      <Link
                                        type="button"
                                        className="btn btn-sm btn-outline-dark"
                                        style={{
                                          height: "28px",
                                          width: "25px",
                                        }}
                                        onClick={() =>
                                          setToggleItemVariationPrice(
                                            !toggleItemVariationPrice
                                          )
                                        }
                                      >
                                        {!toggleItemVariationPrice ? (
                                          <>
                                            <i className="fa fa-plus"></i>{" "}
                                          </>
                                        ) : (
                                          <>
                                            <i className="fa fa-minus"></i>{" "}
                                          </>
                                        )}
                                      </Link>
                                    </th>
                                    {(saleCustomerId || receivingSupplierId)&&( 
                                    <>
                                    <th className="col-1">Last Receiving Price</th>
                                    <th className="col-1">Last Receiving Date</th>
                                    <th className="col-1">Supplier Name</th>
                                    </>
                                  )}
                                    </>
                                  )}
                                </tr>
                                
                                {itemsDetailsData?.Pricing.map(
                                  (items, index) => {
                                    return (
                                      <tr key={index}>
                                        <td className="col-1">
                                          {items?.Name}
                                        </td>
                                        <td className="col-1">
                                          {CurrencySymbols(
                                            Number(items?.SellingPrice),
                                            { CurrencySymbol },
                                            FractionDigits
                                          )}
                                        </td>
                                        {saleCustomerId &&( 
                                        <>
                                        <td className="col-1">
                                          {CurrencySymbols(
                                            Number(items?.SaleTotal),
                                            { CurrencySymbol },
                                            FractionDigits
                                          )}
                                        </td>
                                        <td className="col-1">
                                        {items?.InvoiceDate 
                                          ? moment(items?.InvoiceDate).format(dateFormate.toUpperCase()) 
                                          : ""}
                                          {/* {moment(items?.InvoiceDate).format(`${dateFormate.toUpperCase()}`)} */}
                                        </td>
                                        </>
                                       )}
                                        {checkUserPermission(
                                          "show-cost-price"
                                        ) && (
                                          <>
                                          <td className="col-1">
                                          {toggleItemVariationPrice &&
                                          CurrencySymbols(
                                            Number(items?.CostPrice),
                                            { CurrencySymbol },
                                            FractionDigits
                                          )}
                                          </td>
                                          {toggleItemVariationPrice && (saleCustomerId || receivingSupplierId) &&( 
                                          <>
                                          <td className="col-1">
                                          {CurrencySymbols(
                                            Number(items?.BillTotal),
                                            { CurrencySymbol },
                                            FractionDigits
                                          )}
                                        </td>
                                        <td className="col-1">
                                        {items?.BillDate
                                          ? moment(items?.BillDate).format(dateFormate.toUpperCase()) 
                                          : ""}
                                          {/* {moment(items?.BillDate).format(`${dateFormate.toUpperCase()}`)} */}
                                        </td>
                                        <td className="col-1">
                                          {items?.SupplierName}
                                        </td>
                                        </>
                                         )}
                                        </>
                                        )}
                                      </tr>
                                    );
                                  }
                                )}
                                </>
                              )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      {/* </div> */}
                    </div>
                    <div className="tab-pane" id="ItemsDetailsTabOpen3">
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  <th colSpan={2}>
                                    <p
                                      className="p-medium"
                                      style={{
                                        color: "var(--primary-main-color)",
                                      }}
                                    >
                                      <i
                                        class="fa fa-list-ul mr-3"
                                        aria-hidden="true"
                                      ></i>
                                      Inventory
                                    </p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="col-md-3">Variation</td>
                                  <td className="col-md-3 text-center">
                                    Current Qty.
                                  </td>
                                  <td className="col-md-3 text-center">
                                    Replenish Level
                                  </td>
                                  <td className="col-md-3 text-center">
                                    Reorder Level
                                  </td>
                                </tr>

                                {itemsDetailsData?.Inventory.map(
                                  (items, index) => {
                                    return (
                                      <tr key={index}>
                                        <td className="col-md-3 ">
                                          {Number(items?.ItemVariationId) > 0
                                            ? (() => {
                                                const baseName =
                                                  itemsDetailsData
                                                    ?.ItemInfo?.[0]?.Name ?? "";
                                                const variationName =
                                                  items?.Variation ?? "";

                                                // Create a regex that matches: baseName optionally followed by spaces, a dash, more optional spaces
                                                const pattern = new RegExp(
                                                  `^${baseName}\\s*-\\s*`,
                                                  "i"
                                                );

                                                return variationName
                                                  .replace(pattern, "")
                                                  .trim();
                                              })()
                                            : items?.Variation}
                                        </td>
                                        <td className="col-md-3 text-center">
                                          {Number(items?.Quantity).toFixed(2)}
                                        </td>
                                        <td className="col-md-3 text-center">
                                          {Number(
                                            items?.ReplenishLevel
                                          ).toFixed(2)}
                                        </td>
                                        <td className="col-md-3 text-center">
                                          {Number(items?.ReorderLevel).toFixed(
                                            2
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="ItemsDetailsTabOpen4">
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  <th colSpan={2}>
                                    <p
                                      className="p-medium"
                                      style={{
                                        color: "var(--primary-main-color)",
                                      }}
                                    >
                                      <i
                                        class="fa fa-picture-o mr-3"
                                        aria-hidden="true"
                                      ></i>
                                      Images
                                    </p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {itemsDetailsData?.Images.map(
                                  (items, index) => {
                                    return (
                                      <tr key={index}>
                                        <td className="col-md-1">
                                          <img
                                            // className="d-flex  "
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                            }}
                                            src={items.Name}
                                            alt={items.ID}
                                            width="150"
                                            height="150"
                                          />
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="ItemsDetailsTabOpen5">
                      <div className="row">
                        <div className="col-md-12 mb-3 mt-3">
                        
                          <div className="row">
                            <div className="col-md-3 mb-3 col-form-label p-lg-medium">
                              Variation Filter:
                              <Select
                                onChange={(event) => {
                                  setVariationId(event ? event.value : 0);
                                }}
                                value={
                                  variationDropdown?.find(
                                    (el) => el.value == variationId
                                  ) || null
                                }
                                options={variationDropdown}
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                isClearable={true}
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                className="custom-search-select"
                              />
                            </div>
                            <div className="col-md-3 mb-3 col-form-label p-lg-medium">
                              Customer:
                              <Select
                                onChange={(event) => {
                                  setCustomerId(event ? event.value : 0);
                                }}
                                value={
                                  custoptions?.find(
                                    (el) => el.value == customerId
                                  ) || null
                                }
                                options={custoptions}
                                backspaceRemovesValue={true}
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                controlShouldRenderValue={true}
                                isClearable={true}
                                id="customer"
                                name="customer"
                                className="custom-search-select"
                              />
                            </div>

                            {/* inventorytransaction */}
                            {checkUserPermission("/item-inventory-log-ref-supplier") && (
                              <div className="col-md-3 mb-3 col-form-label p-lg-medium">
                                Supplier:
                                <Select
                                  // defaultValue={supplierValue}
                                  onChange={(event) => {
                                    setSupplierId(event ? event.value : 0);
                                  }}
                                  value={
                                    recoptions?.find(
                                      (el) => el.value == supplierId
                                    ) || null
                                  }
                                  options={recoptions}
                                  backspaceRemovesValue={false}
                                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                  controlShouldRenderValue={true}
                                  isClearable={true}
                                  className="custom-search-select"
                                />
                              </div>
                            )}
                            {/* inventorytransaction */}
                            <div className="col-md-3 mb-3 col-form-label p-lg-medium">
                              Transaction:
                              <Select
                                // defaultValue={supplierValue}
                                onChange={(event) => {
                                  setTransitionId(event ? event.value : 0);
                                }}
                                value={
                                  transactiondropdown?.find(
                                    (el) => el.value == transitionId
                                  ) || null
                                }
                                options={transactiondropdown}
                                backspaceRemovesValue={false}
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                controlShouldRenderValue={true}
                                isClearable={true}
                                className="custom-search-select"
                              />
                            </div>
                          </div>
                          <div className="row mb-3">
                          <div className="pr-2 col-lg-2 col-md-5 col-sm-12">
                              Date Filter:
                              <Select
                                onChange={(event) => {
                                  handleDateSelectChange(event);
                                }}
                                options={options}
                                value={options?.find(el => el.value === selectDateChangeId)}
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                // isClearable={true}
                                // hideSelectedOptions={true}
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                className="custom-search-select"
                              />
                            </div>
                            {selectDateChangeId == 2 && (
                              <>
                                <div className="pr-2 col-lg-2 col-md-6 col-sm-12">
                                  Custom Start Date:
                                  <CommonDatePicker FinalDate={startingDate} handleDateChange={handleStartDateChange}/>
                                </div>
                                <div className="pr-2 col-lg-2 col-md-6 col-sm-12">
                                  Custom End Date:
                                  <CommonDatePicker FinalDate={endingDate} handleDateChange={handleEndDateChange}/>
                                 
                                </div>
                                 {/* <div className="pr-2 col-lg-1 col-md-6 col-sm-12 mt-4">
                                  <button
                                    className="btn btn-dark btn-sm"
                                    onClick={() => handleSearchAccordingToDate()}
                                  >
                                    {" "}
                                    Search{" "}
                                  </button>
                                  </div> */}
                              </>
                            )}
                          </div>
                          <div className="table-responsive">
                            <table className="table">
                            <thead>
                                <tr>
                                  <th className="p-regular">Date</th>
                                  <th className="p-regular">Modified Date</th>
                                  <th className="p-regular">Item Variation</th>
                                  {checkUserPermission("/item-inventory-log-rate") && (
                                  <th className="p-regular">Rate</th>
                                  )}
                                  <th className="p-regular">In/Out Qty</th>
                                  <th className="p-regular">Qty on Hand</th>
                                  <th className="p-regular">Type</th>
                                  {/* <th className="p-regular">ID</th> */}
                                  {checkUserPermission("/item-inventory-log-ref-supplier") && (
                                  <th className="p-regular">Reference</th>
                                  )}
                                     {checkUserPermission("/item-inventory-log-ref") && (
                                  <th className="p-regular"> Invoice / Bill No.</th>
                                  )}
                                  <th className="p-regular">Prev Qty</th>
                                  <th className="p-regular">QB Prev Qty</th>
                                  <th className="p-regular">QB In/Out Qty</th>
                                  <th className="p-regular">Comment</th>
                                </tr>
                              </thead>
                              <tbody>
                              {itemsInventoryData.length > 0 ? (
                                  itemsInventoryData.map((item, index) => (
                                    <tr key={index}>
                                      <td>
                                        {/* {moment(item.TransactionDate).format(
                                          "MM-DD-YYYY hh:mm a"
                                        )} */}
                                        {
                                          moment(item.TransactionDate).format(`${dateFormate.toUpperCase()}`)
                                        }
                                      </td>
                                      <td>
                                        {item.CreatedDate
                                          ? moment(item.CreatedDate).format(`${dateFormate.toUpperCase()} h:mm A`)
                                          : ""}
                                      </td>
                                      <td className="word-break-data">
                                      {
                                        Number(item?.ItemVariationId) > 0 
                                          ? (() => {
                                              const baseName = itemsDetailsData?.ItemInfo?.[0]?.Name ?? '';
                                              const variationName = item?.ItemVariationName ?? '';

                                              // Create a regex that matches: baseName optionally followed by spaces, a dash, more optional spaces
                                              const pattern = new RegExp(`^${baseName}\\s*-\\s*`, 'i');

                                              return variationName.replace(pattern, '').trim();
                                            })()
                                          : item?.ItemName
                                      }

                                      </td>
                                      {checkUserPermission("/item-inventory-log-rate") && (
                                      <td style={{ textAlign: "left" }}>
                                        {Number(item?.Price).toFixed(2)}
                                      </td>
                                  )}
                                      {/* <td style={{ textAlign: "left" }}>
                                        {Number(item?.PastQuanitity).toFixed(2)}
                                      </td> */}
                                      <td style={{ textAlign: "left" }}>
                                        {Number(
                                          item?.InventoryAddSubtraction
                                        ).toFixed(2)}
                                      </td>
                                      <td style={{ textAlign: "left" }}>
                                        {Number(item?.QuantityOnHand).toFixed(
                                          2
                                        )}
                                      </td>
                                      <td> {item?.TransactionType}</td>
                                      {/* <td> {item?.Id}</td> */}
                                      {checkUserPermission("/item-inventory-log-ref-supplier") && (
                                        <td className="word-break-data">
                                        {" "}
                                        {/* {item?.RefrenceNo} */}
                                        {item?.RefrenceNo?.split(",")[0]}
                                      </td>
                                  )}
                                    {checkUserPermission("/item-inventory-log-ref") && (
                                      <td style={{color:"#ffa044"}} className="pos-sale-detail-bold-link word-break-data">
                                    {" "}
                                        {/* {item?.RefrenceNo} */}
                                        <Link style={{color:"#ffa044"}} to={item?.TransactionType == "Receive" ? `/receiving-receipt/${item?.posid}` : item?.TransactionType == ("Sale" || "Return / Memo") ? `/sales-receipt/${item?.posid}`
                                        // : item?.TransactionType == "Return / Memo" ? `/sales-receipt/${item?.posid}`
                                        : '/'}   target="_blank">
                                        {item?.TransactionType == "Receive" ? item?.ReceinigRefNo : item?.TransactionType == "Sale" ? item?.SaleRefNo : item?.TransactionType == "Return / Memo" ? item?.RefNo : ''}
                                        </Link>
                                      </td>
                                    )}
                                      <td className="word-break-data"> {item.TransactionType == "Inventory Adjustment" ? Number(item?.ActualQuantity).toFixed(2) : "-"}</td>
                                      <td className="word-break-data"> {item.TransactionType == "Inventory Adjustment" ? Number(item?.QuickbookQtyOnHand).toFixed(2) : "-"}</td>
                                      <td className="word-break-data"> {item.TransactionType == "Inventory Adjustment" ? Number(item?.Quickbookentqty).toFixed(2) : "-"}</td>
                                      <td className="word-break-data"> {item?.Comment}</td>
                                      {/* <td> {item?.CompanyName}</td> */}
                                    </tr>
                                  ))
                                ) : (
                                  <tr
                                    style={{
                                      textAlign: "center",
                                      columnSpan: 6,
                                    }}
                                  >
                                    <td>No Data</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="ItemsDetailsTabOpen6">
                      <div className="row">
                        <div className="col-md-12 p-3">
                           <div className="table-responsive">
                          <table className="table mb-0 table-border">
                            <thead>
                              <tr>
                                <th colSpan={2}>
                                  <p className="p-medium" style={{ color: 'var(--primary-main-color)' }}>
                                    <i className="fa fa-list-ul mr-3" aria-hidden="true"></i>
                                    Inventory
                                  </p>
                                </th>
                              </tr>
                              <tr>
                                <th onClick={() => handleSort('Variation')}>Variation {getSortIcon('Variation')}</th>
                                <th className="text-center" onClick={() => handleSort('Quantity')}>
                                  <span style={{ whiteSpace: 'nowrap' }}>
                                    Current Qty. {getSortIcon('Quantity')}
                                  </span>
                                </th>
                                <th className="text-center" onClick={() => handleSort('AvgQty_1W')}>
                                  1W<br />
                                  <small><span style={{ whiteSpace: 'nowrap' }}>(Last 7 days)</span></small> {getSortIcon('AvgQty_1W')}
                                </th>
                                <th className="text-center" onClick={() => handleSort('AvgQty_2W')}>
                                  2W<br />
                                  <small><span style={{ whiteSpace: 'nowrap' }}>(Last 14 days)</span></small> {getSortIcon('AvgQty_2W')}
                                </th>
                                <th className="text-center" onClick={() => handleSort('AvgQty_4W')}>
                                  4W<br />
                                  <small><span style={{ whiteSpace: 'nowrap' }}>(Last 28 days)</span></small> {getSortIcon('AvgQty_4W')}
                                </th>
                                <th className="text-center" onClick={() => handleSort('AvgQty_8W')}>
                                  8W<br />
                                  <small><span style={{ whiteSpace: 'nowrap' }}>(Last 56 days)</span></small> {getSortIcon('AvgQty_8W')}
                                </th>
                                <th className="text-center" onClick={() => handleSort('AvgQty_12W')}>
                                  12W<br />
                                  <small><span style={{ whiteSpace: 'nowrap' }}>(Last 84 days)</span></small> {getSortIcon('AvgQty_12W')}
                                </th>
                                <th className="text-center" onClick={() => handleSort('AvgQty_16W')}>
                                  16W<br />
                                  <small><span style={{ whiteSpace: 'nowrap' }}>(Last 112 days)</span></small> {getSortIcon('AvgQty_16W')}
                                </th>
                                <th className="text-center" onClick={() => handleSort('OverallAvgPerDay')}>
                                  <span style={{ whiteSpace: 'nowrap' }}>Overall Avg {getSortIcon('OverallAvgPerDay')}</span>
                                </th>
                                <th className="text-center" onClick={() => handleSort('WMA_Avg')}>
                                  <span style={{ whiteSpace: 'nowrap' }}>WMA {getSortIcon('WMA_Avg')}</span>
                                </th>
                                <th className="text-center" onClick={() => handleSort('Days_Left')}>
                                  Days of<br />
                                  <span style={{ whiteSpace: 'nowrap' }}>Stock Left {getSortIcon('Days_Left')}</span>
                                </th>
                                <th className="text-center" onClick={() => handleSort('ReorderQty')}>
                                  Reorder<br />
                                  <span style={{ whiteSpace: 'nowrap' }}>Level {getSortIcon('ReorderQty')}</span>
                                </th>
                                <th className="text-center" onClick={() => handleSort('ReplenishQty')}>
                                  Replenish<br />
                                  <span style={{ whiteSpace: 'nowrap' }}>Qty {getSortIcon('ReplenishQty')}</span>
                                </th>
                                <th className="text-center" onClick={() => handleSort('ReorderNeeded')}>
                                  Reorder<br />
                                  <span style={{ whiteSpace: 'nowrap' }}>Needed {getSortIcon('ReorderNeeded')}</span>
                                </th>
                                <th className="text-center" onClick={() => handleSort('SuggestedOrderQty')}>
                                  Suggested<br />
                                  <span style={{ whiteSpace: 'nowrap' }}>Order Qty {getSortIcon('SuggestedOrderQty')}</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {sortedInventory.map((items, index) => (
                                <tr key={index}>
                                  <td>
                                    {Number(items?.ItemVariationId) > 0
                                      ? (() => {
                                          const baseName = itemsDetailsData?.ItemInfo?.[0]?.Name ?? '';
                                          const variationName = items?.VariationName ?? '';
                                          const pattern = new RegExp(`^${baseName}\\s*-\\s*`, 'i');
                                          return variationName.replace(pattern, '').trim();
                                        })()
                                      : items?.VariationName}
                                  </td>
                                  <td className="text-center">{Number(items?.Quantity).toFixed(2)}</td>
                                  <td className="text-center">{Number(items?.TotalQty_1W).toFixed(2)} | {Number(items?.AvgQty_1W).toFixed(2)}</td>
                                  <td className="text-center">{Number(items?.TotalQty_2W).toFixed(2)} | {Number(items?.AvgQty_2W).toFixed(2)}</td>
                                  <td className="text-center">{Number(items?.TotalQty_4W).toFixed(2)} | {Number(items?.AvgQty_4W).toFixed(2)}</td>
                                  <td className="text-center">{Number(items?.TotalQty_8W).toFixed(2)} | {Number(items?.AvgQty_8W).toFixed(2)}</td>
                                  <td className="text-center">{Number(items?.TotalQty_12W).toFixed(2)} | {Number(items?.AvgQty_12W).toFixed(2)}</td>
                                  <td className="text-center">{Number(items?.TotalQty_16W).toFixed(2)} | {Number(items?.AvgQty_16W).toFixed(2)}</td>
                                  <td className="text-center">{Number(items?.OverallAvgPerDay).toFixed(2)}</td>
                                  <td className="text-center">{Number(items?.WMA_Avg).toFixed(2)}</td>
                                  {/* <td className="text-center">{Number(items?.Days_Left).toFixed(2)}</td> */}
                                  <td className="text-center">{items?.ShowInfinite == 1 ? '∞' : Number(items?.Days_Left).toFixed(2)}</td>
                                  <td className="text-center">{items?.ReorderQty}</td>
                                  <td className="text-center">{items?.ReplenishQty}</td>
                                  <td className="text-center">{items?.ReorderNeeded}</td>
                                  <td className="text-center">{items?.SuggestedOrderQty}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="modal-footer justify-content-center">
              <Link
                className="btn btn-sm btn-outline-dark me-1 form-control text-align-center"
                data-bs-dismiss="modal"
              >
                Close
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemsDetailsModal;
